import { useState } from 'react';
import { Modal, Box, TextField, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  onClose: () => void;
  onSave: (newName: string) => void;
  currentName: string;
}

export const CaseRenameModal = ({ open, onClose, onSave, currentName }: Props) => {
  const [newName, setNewName] = useState(currentName);
  const { t } = useTranslation();

  const handleSave = () => {
    onSave(newName);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="rename-entity-modal" aria-describedby="rename-entity-modal-description">
      <Box
        sx={{
          position: 'absolute',
          display: 'flex',
          flexDirection: 'column',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 2,
          borderRadius: 1,
        }}
      >
        <TextField
          label={t('cases.view.case')}
          fullWidth
          variant="outlined"
          margin="normal"
          value={newName}
          size="small"
          onChange={(e) => setNewName(e.target.value)}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={onClose} size="small">
            {t('common.cancel')}
          </Button>
          <Button variant="contained" onClick={handleSave} size="small">
            {t('common.save')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
